import ProductReviewFilter from "./product-review-filter";
import ProductReviewList from "./product-review-list";
import {useDispatch, useSelector} from "react-redux";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import {useEffect} from "react";
import {setToolsInitialState} from "../../reducers/tools.reducer";
import {setReviewInitialState} from "../../reducers/review.reducer";
import {SORT_LIST_REVIEW} from "../../utils/sort-list";
import {useEffectAfterMount} from "../../services/useEffectAfterMount";

const ProductReviewPage = () => {
    const dispatch = useDispatch()
    const defaultSort = SORT_LIST_REVIEW?.find(item => item.isDefault)
    const getOrderBy = defaultSort?.key.split('_')
    const {
        currentPage,
        pageSize,
        orderBy,
        sort,
        searchKey,
        reload
    } = useSelector(state => state.toolsReducer)
    const queryParams = {
        page: currentPage,
        perPage: pageSize,
        orderBy: !!orderBy ? orderBy : getOrderBy[0],
        orderType: sort,
        search: searchKey
    }
    const {
        data: response,
        fetching: getProductReviewList,
        isLoading
    } = useFetch(API.PRODUCT_REVIEW_LIST, queryParams, {isWithTotalData: true})

    useEffect(() => {
        return () => {
            dispatch(setToolsInitialState())
            dispatch(setReviewInitialState())
        }
    }, [])

    useEffectAfterMount(() => {
        getProductReviewList()
    }, [currentPage, pageSize, orderBy, sort, searchKey, reload])

    return (
        <div className={"col px-10"}>
            <ProductReviewFilter/>
            <ProductReviewList dataSource={response?.data?.result ?? []} isLoading={isLoading}/>
        </div>
    )
}

export default ProductReviewPage